/* eslint-disable camelcase */
import { WithDataFetchParams } from '@shared/redux/commons.types';

export enum ConversionTypes {
    PURCHASE = 'offsite_conversion.fb_pixel_purchase',
    ADD_TO_CARD = 'offsite_conversion.fb_pixel_add_to_cart',
    CHECKOUT = 'offsite_conversion.fb_pixel_initiate_checkout',
    LEAD = 'offsite_conversion.fb_pixel_lead',
}

export interface ConversionTypeData {
    conversionTypeCollection: ConversionTypeCollection,
}

export interface ConversionType {
    conversion_types: Array<string>;
}

export interface ConversionTypeCollection {
    loadState: string,
    data: ConversionType,
    error: string,
}

export type IConversionTypes = WithDataFetchParams<Array<string>>;
